import React from 'react';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  clearError() {
    this.setState({ hasError: false });
  }

  // noinspection JSUnusedGlobalSymbols
  static getDerivedStateFromError(error) {
    console.error('ErrorBoundary.getDerivedStateFromError', error);
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.errorView;
    }

    return this.props.children;
  }
}

export { AppErrorBoundary };
